//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from "weixin-js-sdk"
import global_ from "./global";

export default {
  name: "PcLogin",
  data() {
    return {
      uuid: this.$route.query.uuid,
      accountInfo: []
    }
  },
  methods: {
    async getData() {
      const openid = localStorage.getItem('openid');
      const unionid = localStorage.getItem('unionid')
      const {data} = await this.$http.get('/api/v1/wechat/' + unionid)
      this.accountInfo = data.filter(item => {
        return item.role === 'SRVP' || item.role === 'ADMIN'
      }).map(item => {
        switch (item.role) {
          case 'SRVP':
            item.role = '服务商管理员';
            break;
          case 'ADMIN':
            item.role = '超级管理';
            break;
        }
        return item
      })
      if (this.accountInfo.length === 0) {
        this.$vux.alert.show({
          title: "",
          content: "您还没有关联好云帷管理员账号，请在网页端继续输入账号信息进行关联，关联之后可以通过此微信快速登录好云帷平台。",
          onHide: async () => {
            const response = await this.$http.post('/api/v1/accounts/bond_uuid', {
              uuid: this.uuid,
              openid: localStorage.getItem('openid'),
              unionid: localStorage.getItem('unionid'),
              otp:'official'
            })
            wx.closeWindow()
          }
        });
      }
    },
    async login(account) {
      try {
        const response = await this.$http.post('/api/v1/accounts/bond_uuid', {
          uuid: this.uuid,
          openid: localStorage.getItem('openid'),
          unionid: localStorage.getItem('unionid'),
          otp:'official',
          account
        })
        if (response) {
          alert('登录成功')
          wx.closeWindow()
        }
      } catch (err) {
        this.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        })
      }
    }
  },
  mounted() {
    setTimeout(() => {
      const timestamp = parseInt(new Date().getTime() / 1000)
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      this.$http.get('static/config.json').then(response => {
        const config = response.data
        const url = isiOS ? config.host + global_.entryUrl : config.host + this.$route.fullPath;
        const noncestr = Math.random().toString(36).substr(2)
        this.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
          .then((response) => {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: config.appId, // 必填，公众号的唯一标识
              timestamp: timestamp, // 必填，生成签名的时间戳
              nonceStr: noncestr, // 必填，生成签名的随机串
              signature: response.data, // 必填，签名
              jsApiList: ['checkJsApi'] // 必填，需要使用的JS接口列表
            })
            wx.error(function (res) {
              alert(res.errMsg)
            })
            wx.ready(() => {
            })
          })
          .catch((error) => {
            alert('服务器错误，请稍后重试')
            if (error.response) {
              console.log(error.response.data)
            } else if (error.request) {
              console.log(error.request)
            } else {
              console.log('Error', error.message)
            }
          })
      }, response => {
        console.log('数据加载失败')
      })
    }, 500)
  },
  created() {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/components/PcLogin.vue